// --- from PrintElement.ts ---
export interface PrintElement {
  printer: string;
  url?: string;
  title?: string;
  copies: number;
  format: string;
  bothSides: boolean;
  data: string;
  base64: boolean;
}

// --- from PrintLog.ts ---
export type PrintJobStatus = 'pending' | 'sent' | 'failed' | 'skipped';

export interface PrintLog {
  /** Present on logs that can be updated once QZ Tray answers (see PrintHandler) */
  id?: string;
  date: string | Date;
  type: string;
  name: string;
  link: string;
  /** OS name of the printer the job was sent to */
  printer?: string;
  status?: PrintJobStatus;
  /** Time between the call to QZ Tray and its answer (job handed to the spooler), not the physical print time */
  durationMs?: number;
  error?: string;
}

/** What QZ Tray reports for an installed printer (`qz.printers.details()`); only the fields we rely on. */
export interface QzPrinterDetails {
  name: string;
  driver?: string;
  default?: boolean;
  connection?: string;
}

/** Last status event received from QZ Tray for a printer */
export interface PrinterRuntimeStatus {
  status: string;
  receivedAt: number;
}

// --- from Printer.ts ---
export interface Printer {
  type: string;
  name: string;
  originalName: string;
}

// --- from PrinterEnum.ts ---
export enum PrinterEnum {
  Barcode = 'BARCODE',
}
